import React, { useState, useRef, useEffect } from 'react';
import { Wrapper } from './style';
import OrderItems from './lib/order-items';
import Products from './lib/products';
import { MakeApiCall } from "../../../../apis";
import { ConvertParams } from "../../../../config";
import { message, Spin } from "antd";
import { exportToExcel } from "../../../../utils/excelExport";

const ItemMaster = ({ userData, selectedMarketplace, selectedCurrencySign, selectedTileData }) => {
    const [activeView, setActiveView] = useState('products');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef();
    const [loading, setLoading] = useState(false); // 👈 state for spinner

    const getProductList = async (filter, forExport = false) => {
        setLoading(true); // start spinner
        try {
            const response = await MakeApiCall(
                `dashboard/tiles/get-product-analytics-data${ConvertParams(filter)}`,
                "get",
                null,
                true,
                {},
                userData?.token
            );

            if (response?.status) {
                const records = response?.data?.records?.summaryData || [];
                const labels = response?.data?.records?.label || {};

                if (forExport) {
                    exportToExcel(records, labels, "products.xlsx");
                } else {
                    // pagination state updates (if needed)
                    // setList(records);
                }
            } else {
                message.warning(response?.message);
            }
        } catch (error) {
            message.error("Something went wrong while exporting.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleDropdown = () => setDropdownOpen((prev) => !prev);
    const selectView = (view) => {
        setActiveView(view);
        setDropdownOpen(false);
    };

    const handleExport = () => {
        const filter = {
            marketplace_id: selectedMarketplace?.id,
            start_date: selectedTileData?.start_date,
            end_date: selectedTileData?.end_date,
            no_pagination: true, // ensures full data
        };
        getProductList(filter, true);
    };

    return (
        <Wrapper>
            <div className="card card-xxl-stretch mb-5 mb-xl-8 mt-4 border-0 shadow-sm rounded-4">
                {/* Header */}
                <div className="card-header bg-transparent pb-0 px-5 pt-5 d-flex flex-wrap align-items-center">
                    <div className="dropdown position-relative" ref={dropdownRef}>
                        <button
                            className="btn btn-danger btn-lg fw-semibold px-10 py-2 rounded-1 shadow-sm border"
                            onClick={toggleDropdown}
                        >
                            {activeView === 'products' ? 'Products' : 'Order Items'}
                            <i className="ms-2 bi bi-caret-down-fill"></i>
                        </button>
                        <ul
                            className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}
                            style={{
                                width: "100%",
                                minWidth: "unset",
                                boxSizing: "border-box"
                            }}
                        >
                            <li>
                                <button
                                    className={`dropdown-item ${activeView === 'products' ? 'active' : ''}`}
                                    onClick={() => selectView('products')}
                                    style={{
                                        backgroundColor: activeView === 'products' ? '#dc3545' : '#f8f9fa',
                                        color: activeView === 'products' ? '#fff' : '#000',
                                        fontWeight: 500,
                                        padding: "10px 15px",
                                        borderRadius: 4,
                                        marginBottom: 5,
                                        border: "1px solid #dee2e6"
                                    }}
                                >
                                    <i className="ki-outline ki-purchase me-2 text-primary"/>
                                    Products
                                </button>
                            </li>
                            <li>
                                <button
                                    className={`dropdown-item ${activeView === 'orderItems' ? 'active' : ''}`}
                                    onClick={() => selectView('orderItems')}
                                    style={{
                                        backgroundColor: activeView === 'orderItems' ? '#dc3545' : '#f8f9fa',
                                        color: activeView === 'orderItems' ? '#fff' : '#000',
                                        fontWeight: 500,
                                        padding: "10px 15px",
                                        borderRadius: 4,
                                        border: "1px solid #dee2e6"
                                    }}
                                >
                                    <i className="ki-outline ki-handcart me-2 text-primary"/>
                                    Order Items
                                </button>
                            </li>
                        </ul>
                    </div>
                    {/* Export Button with Spinner */}
                    { activeView === 'products' && (
                        <button
                            className="btn btn-dark fs-7 fw-bold ms-3 d-flex align-items-center"
                            onClick={handleExport}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <Spin size="small" className="me-2"/> Exporting...
                                </>
                            ) : (
                                <>
                                    Export <i className="ms-1 bi bi-upload fs-4"/>
                                </>
                            )}
                        </button>
                    )
                    }
                </div>

                {/* Body */}
                <div className="card-body pt-4 px-5">
                    {activeView === 'products' && (
                        <Products
                            selectedTileData={selectedTileData}
                            userData={userData}
                            selectedCurrencySign={selectedCurrencySign}
                            selectedMarketplace={selectedMarketplace}
                        />
                    )}
                    {activeView === 'orderItems' && (
                        <OrderItems
                            selectedTileData={selectedTileData}
                            userData={userData}
                            selectedCurrencySign={selectedCurrencySign}
                            selectedMarketplace={selectedMarketplace}
                        />
                    )}
                </div>
            </div>
        </Wrapper>
    );
};

export default ItemMaster;